/*
 * GENERATED FILE - DO NOT HAND-EDIT
 * Provenance: extracted byte-identical from assets/theme.js on 2026-08-11 (theme-js-split round 2 corrected by actual page-type usage).
 * Contents: rich bundle: 20 classes for index/product/extended-suffix pages (needs_full_vendor). Load order: after theme-core.js. Round 2: absorbs round-1 theme-home.js membership (home bundle eliminated).
 * Regenerate: one-off extraction script (kept in $TEMP, not in repo) per .omo/plans/theme-js-split.md.
 */

class ProductStickyForm extends HTMLElement {
  constructor() {
    super();

    this.scopeFrom =
      document.querySelector(".quick-order-list") ||
      document.getElementById(this.getAttribute("form"));
    this.scopeTo = document.querySelector(".footer-group");

    if (!this.scopeFrom || !this.scopeTo) {
      return;
    }

    const intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this)
    );
    intersectionObserver.observe(this.scopeFrom);
    intersectionObserver.observe(this.scopeTo);

    this.onVariantChangedListener = this.onVariantChanged.bind(this);

    this.querySelector('.close-btn')?.addEventListener('click', () => {
      this.style.display = 'none'
    })
  }

  get productForm() {
    return document.forms[this.getAttribute("form")];
  }

  get submitButton() {
    return (this._submitButton =
      this._submitButton || this.querySelector('[type="submit"]'));
  }

  get productOptions() {
    return (this._productOptions =
      this._productOptions ||
      this.querySelector("[data-sticky-product-options]"));
  }

  get productMedia() {
    return (this._productMedia =
      this._productMedia ||
      this.querySelector("[data-sticky-product-media]"));
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.scopeFrom) {
        this.scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this.scopeTo) {
        this.scopeToReached = entry.isIntersecting;
      }
    });

    if (this.scopeFromPassed && !this.scopeToReached) {
      Motion.animate(
        this.firstElementChild,
        {
          opacity: 1,
          visibility: "visible",
          transform: ["translateY(15px)", "translateY(0)"],
        },
        { duration: 1, easing: [0.16, 1, 0.3, 1] }
      );
    } else {
      Motion.animate(
        this.firstElementChild,
        {
          opacity: 0,
          visibility: "hidden",
          transform: ["translateY(0)", "translateY(15px)"],
        },
        { duration: 1, easing: [0.16, 1, 0.3, 1] }
      );
    }
  }

  connectedCallback() {
    (this.productForm ?? document).addEventListener(
      "variant:change",
      this.onVariantChangedListener
    );
  }

  disconnectedCallback() {
    (this.productForm ?? document).removeEventListener(
      "variant:change",
      this.onVariantChangedListener
    );
  }

  onVariantChanged(event) {
    this.updateProductMedia(event.detail.variant);
    this.updateProductOptions(event.detail.variant);
  }

  updateProductMedia(currentVariant) {
    if (!currentVariant || !currentVariant.featured_media) return;

    const image = this.productMedia.querySelector("img");
    const newImage = new Image(
      currentVariant.featured_media.preview_image.width,
      currentVariant.featured_media.preview_image.height
    );

    newImage.alt = currentVariant.featured_media.alt;
    newImage.src = currentVariant.featured_media.preview_image.src;
    newImage.srcset = this.generateSrcset(
      currentVariant.featured_media.preview_image
    );
    newImage.sizes = image.sizes;

    this.productMedia.replaceChildren(newImage);
  }

  updateProductOptions(currentVariant) {
    if (!currentVariant) return;

    this.productOptions.innerText = currentVariant.title;
  }

  handleErrorMessage(errorMessage = false) {
    if (this.productForm?.hideErrors) return;

    this.errorMessage =
      this.errorMessage ||
      this.querySelector(".product-form__error-message");
    if (!this.errorMessage) return;

    this.errorMessage.toggleAttribute("hidden", !errorMessage);
    this.errorMessage.innerText = errorMessage;
  }

  toggleSubmitButton(disable = true, text) {
    if (!this.submitButton) return;

    const submitButtonText = this.submitButton.querySelector(".btn-text");
    const submitButtonTextChild =
      this.submitButton.querySelector(".btn-text>span");

    if (disable) {
      this.submitButton.setAttribute("disabled", "");
      if (text) {
        (submitButtonTextChild || submitButtonText).textContent = text;
      }
    } else {
      this.submitButton.removeAttribute("disabled");
      (submitButtonTextChild || submitButtonText).textContent =
        this.submitButton.hasAttribute("data-pre-order")
          ? theme.variantStrings.preOrder
          : theme.variantStrings.addToCart;
    }
  }

  generateSrcset(image) {
    const widths = this.productMedia
      .getAttribute("data-widths")
      .split(",")
      .map((width) => parseInt(width));
    return widths
      .filter((width) => width <= image.width)
      .map((width) => {
        return `${image.src}&width=${width} ${width}w`;
      })
      .join(", ");
  }
}
customElements.define("product-sticky-form", ProductStickyForm);


class RevealBanner extends HTMLElement {
  constructor() {
    super();

    Motion.inView(this, this.init.bind(this), {
      margin: "600px 0px 600px 0px",
    });
  }

  init() {
    const tracker = this.querySelector(".reveal-banner__tracker");
    Motion.scroll(
      Motion.animate(
        this.querySelectorAll(".banner__media"),
        {
          clipPath: [
            "inset(20% 35% 0% 35% round var(--rounded-block))",
            "inset(0% 0%)",
          ],
        },
        { easing: "linear" }
      ),
      { target: tracker, offset: Motion.ScrollOffset.Enter }
    );

    const tracker2nd = this.querySelector(".reveal-banner__tracker2nd");
    if (tracker2nd) {
      Motion.scroll(
        Motion.timeline([
          [
            this.querySelector(".banner__overlay"),
            { opacity: [0, 1] },
            { easing: "linear" },
          ],
          [
            this.querySelector(".banner__content"),
            {
              opacity: [0, 1],
              visibility: ["hidden", "visible"],
              transform: ["translateY(10%)", "translateY(0)"],
            },
            { easing: "linear", at: "<" },
          ],
        ]),
        { target: tracker2nd, offset: Motion.ScrollOffset.Enter }
      );
    }
  }
}
customElements.define("reveal-banner", RevealBanner);


class SplittingBanner extends HTMLElement {
  constructor() {
    super();

    Motion.inView(this, this.init.bind(this), {
      margin: "600px 0px 600px 0px",
    });
  }

  init() {
    const splitting = Splitting({
      target: this.querySelector(".splitting"),
      by: "chars",
      whitespace: true,
    });

    const wrapper = this.querySelector(".splitting-wrapper");
    const tracker = this.querySelector(".reveal-banner__tracker");
    Motion.scroll(
      Motion.timeline([
        [
          splitting[0].chars,
          { opacity: [0.3, 1] },
          {
            delay: theme.config.motionReduced
              ? 0
              : Motion.stagger(0.1),
          },
        ],
        //[wrapper, { transform: ['translateY(-20vh)', 'translateY(0)'] }, { easing: 'linear', at: '<' }]
      ]),
      { target: tracker, offset: Motion.ScrollOffset.Enter }
    );

    Motion.scroll(
      Motion.animate(
        wrapper,
        { opacity: theme.config.mqlSmall ? [1, 0, 0] : [1, 1, 0] },
        { easing: "linear" }
      ),
      { target: tracker, offset: Motion.ScrollOffset.Exit }
    );

    const tracker2nd = this.querySelector(".reveal-banner__tracker2nd");
    if (tracker2nd) {
      Motion.scroll(
        Motion.animate(
          this.querySelector(".button-wrapper"),
          {
            opacity: [0, 1, 1],
            transform: ["translateY(100%)", "translateY(0)"],
          },
          { easing: "linear" }
        ),
        { target: tracker2nd, offset: Motion.ScrollOffset.Enter }
      );
    }
  }
}
customElements.define("splitting-banner", SplittingBanner);


class RevealVideoWithText extends HTMLElement {
  constructor() {
    super();

    Motion.inView(this, this.init.bind(this), {
      margin: "600px 0px 600px 0px",
    });
  }

  init() {
    const splitting = Splitting({
      target: this.querySelector(".splitting"),
      by: "chars",
      whitespace: true,
    });

    const wrapper = this.querySelector(".splitting-wrapper");
    const tracker = this.querySelector(".reveal-banner__tracker");

    Motion.scroll(
      Motion.animate(
        wrapper,
        {
          opacity: theme.config.mqlSmall
            ? [1, 0.5, 0.3, 0]
            : [1, 0.5, 0.3, 0],
        },
        { easing: "linear" }
      ),
      { target: tracker, offset: Motion.ScrollOffset.Exit }
    );

    // 视频滚动播放控制
    const videoContainer = this.querySelector(".scroll-video");
    const videoPc = videoContainer.querySelector(".reveal-video__pc");
    const videoMobile = videoContainer.querySelector(
      ".reveal-video__mobile"
    );
    const bannerBox = this.querySelector(".banner__box");

    // 视口宽度
    const isMobile = window.innerWidth <= 767;
    if (videoContainer) {
      // 查找实际的video元素，可能在容器内部
      const video = isMobile
        ? videoMobile
          ? videoMobile
          : videoContainer.querySelector("video")
        : videoPc
        ? videoPc
        : videoContainer.querySelector("video");

      // 起始点：视频元素有1/5的身体进入视口时开始触发滚动逻辑
      const startThreshold = 0.2;
      // 结束点：视频元素顶边超过banner__box元素顶边的比例（相对于视频高度）
      const endThreshold = 0.2;

      // 确保视频已加载
      const videoReady = new Promise((resolve) => {
        if (video.readyState >= 3) {
          resolve();
        } else {
          video.addEventListener("canplay", () => resolve(), {
            once: true,
          });
          // 只有在video元素有load方法时才调用
          if (typeof video.load === "function") {
            video.load();
          }
        }
      });

      videoReady.then(() => {
        // 获取实际视频时长
        const realDuration = video.duration || 3;

        // 基于滚动位置设置视频时间
        const scrollHandler = () => {
          // 获取视频元素的位置和尺寸
          const videoRect = video.getBoundingClientRect();
          const bannerBoxRect = bannerBox.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          // 计算视频在视口中的可见比例 (0-1范围)
          let visibleRatio = 0;

          // 如果视频顶部已进入视口
          if (videoRect.top < viewportHeight) {
            // 计算已进入视口的高度
            const visibleHeight = Math.min(
              videoRect.height,
              viewportHeight - videoRect.top
            );
            // 计算可见比例
            visibleRatio = visibleHeight / videoRect.height;
          }

          // 计算滚动进度 (0-1范围)
          let scrollProgress = 0;

          // 只有当视频可见比例超过阈值时才开始计算进度
          if (visibleRatio >= startThreshold) {
            // 计算从起始点(视频20%进入视口)到结束点(视频顶部超过banner__box顶部20%)的总距离
            const startPosition =
              viewportHeight - videoRect.height * startThreshold;
            // 结束位置：banner__box顶部减去视频高度的endThreshold比例
            const endPosition =
              bannerBoxRect.top - videoRect.height * endThreshold;
            const totalDistance = startPosition - endPosition;

            // 计算当前进度
            if (totalDistance > 0) {
              const currentPosition = Math.max(
                videoRect.top,
                endPosition
              );
              scrollProgress =
                1 -
                (currentPosition - endPosition) / totalDistance;
              // 确保进度在0-1范围内
              scrollProgress = Math.max(
                0,
                Math.min(1, scrollProgress)
              );
            }
          }

          // 设置视频当前时间（基于滚动进度）
          const targetTime = scrollProgress * realDuration;

          // 当视频时间与目标时间差异较大时，设置时间点
          if (Math.abs(video.currentTime - targetTime) > 0.1) {
            video.currentTime = targetTime;
          }
        };

        // 添加滚动事件监听
        window.addEventListener("scroll", scrollHandler, {
          passive: true,
        });

        // 确保初始状态正确
        scrollHandler();

        // 组件销毁时清理事件监听
        this.cleanup = () => {
          window.removeEventListener("scroll", scrollHandler);
        };
      });
    }
  }

  disconnectedCallback() {
    if (this.cleanup) {
      this.cleanup();
    }
  }
}
customElements.define("reveal-video-with-text", RevealVideoWithText);


/*
  基于Swiper库的封装，用法：
  ------------------------------------------------------------------------------------------------------------
  <swiper-component>
    <script data-swiper-options type="application/json">
      {
        "usePage": true,
        "useNav": true,
        "pageBottom": false,
        "paddingRight": "100px"
      }
    </script>
    <script data-swiper-options type="application/json">
      {
        "usePage": false
      }
    </script>
    <div class="swiper">
      <div class="swiper-wrapper">
        {%- for block in section.blocks -%}
          <div class="swiper-slide">Slide {{ forloop.index }}</div>
        {%- endfor -%}
      </div>
    </div>
  </swiper-component>
  ------------------------------------------------------------------------------------------------------------

  配置项如何定义：
    在swiper-component里面定义json模版，可以定义多个，后面的会覆盖前面的属性。
    <script data-swiper-options type="application/json">
      { "usePage": true }
    </script>

  SwiperComponent的配置项：
    usePage: {Boolean} 是否使用分页栏
    pageBottom: {Boolean} true时分页栏在底部，false时分页栏在底部浮动（盖住swiper-slide）
    useNav: {Boolean} 是否使用导航按钮
    navPosition: {String} 导航按钮的位置，可选值：
      float: 左右两侧浮动
      title: 放到section-heading.liquid的右侧
    paddingRight: {String} 分页栏的右边距，如果想在右边展示一部分内容，可设置一个偏移量，比如100px
    sameHeight: {Boolean} true表示所有slide item的高度和"最高"的那个一样高。
    enableDesktop: {Boolean} 是否启用PC端swiper。
    enableMobile: {Boolean} 是否启用移动端swiper。


  其他的配置项均是Swiper的配置项，具体请查看Swiper官方文档。

  关于UI的样式请自行定义，请查看theme.css的swiper-component部分。
 */
class SwiperComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 合并所有的配置项
    const optionArray = []
    this.querySelectorAll('script[data-swiper-options]').forEach(sc => {
      optionArray.push(JSON.parse(sc.textContent))
    })
    let tmp = {}
    for (let i = 0; i < optionArray.length; i++) {
      tmp = SwiperComponent.deepMerge(tmp, optionArray[i])
    }
    this.customOptions = tmp

    // 这两个决定导航按钮和分页栏是否展示出来
    if (!this.customOptions.enableDesktop) {
      this.classList.add('disabled-swiper-desktop')
    }
    if (!this.customOptions.enableMobile) {
      this.classList.add('disabled-swiper-mobile')
    }

    /* ================= swiper初始化 START ================= */
    this.swiperElement = this.querySelector('.swiper')

    const options = SwiperComponent.deepMerge({
      enableMobile: true,
      enableDesktop: true,
      usePage: true,
      useNav: true,
      pageBottom: true,
      slidesPerView: 2,
      spaceBetween: 20,
      paddingRight: "0",
      paddingRightMobile: "0"
    }, this.customOptions)
    this.options = options

    if (options.pageBottom) {
      this.classList.add('pagination-bottom')
    }

    let pagination = null
    let navigation = null
    // 分页栏
    if (options.usePage === true) {
      const paginationElement = document.createElement('span')
      paginationElement.classList.add('swiper-pagination')
      this.swiperElement.appendChild(paginationElement)
      options.pagination = { el: paginationElement, clickable: true }
      this.paginationElement = paginationElement
    }

    // 导航按钮
    if (options.useNav === true) {
      const navElementPrev = document.createElement('span')
      navElementPrev.classList.add('swiper-nav-button')
      navElementPrev.classList.add('swiper-button-prev')
      this.swiperElement.appendChild(navElementPrev)

      const navElementNext = document.createElement('span')
      navElementNext.classList.add('swiper-nav-button')
      navElementNext.classList.add('swiper-button-next')
      this.swiperElement.appendChild(navElementNext)
      options.navigation = { nextEl: navElementNext, prevEl: navElementPrev }
      this.navNextElement = navElementNext
    }


    this.swiper = new Swiper(this.swiperElement, options);
    /* ================= swiper初始化 END ================= */

    // 监听视口变化，更新导航按钮的位置
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    mediaQuery.addEventListener('change', this.onMediaQueryChanged.bind(this));
    this.onMediaQueryChanged(mediaQuery);
    this.initNavPosition()

    // sameHeight配置，使每个slide item的高度统一的处理代码
    if (options.sameHeight) {
      const onWindowSizeChanged = theme.utils.debounce(() => {
        this.updateSlideItemHeightToMaxHeight(this.swiper)
      }, 300)

      const observer = new ResizeObserver(entries => {
        onWindowSizeChanged()
      });
      observer.observe(document.body);
    }
  }

  initNavPosition () {
    if (this.customOptions.navPosition.includes('title')) {
      const navContainer = this.closest('.shopify-section').querySelector('.section-title-container .swiper-nav-button-container')
      this.swiperElement.querySelectorAll('.swiper-nav-button').forEach(btn => {
        navContainer.appendChild(btn)
      })
    }
  }

  onMediaQueryChanged (e) {
    if (e.matches) {
      this.style.paddingRight = this.options.enableMobile ? this.options.paddingRightMobile : 0
    } else {
      this.style.paddingRight = this.options.enableDesktop ? this.options.paddingRight : 0
    }
    if (!this.customOptions.navPosition || this.customOptions.navPosition === 'float') {
      this.adjustPositionByPaddingRight(this.style.paddingRight)
    }
  }

  adjustPositionByPaddingRight(paddingRight) {
    if (this.paginationElement) {
      this.paginationElement.style.transform = `translateX(calc(${paddingRight} / 2))`
    }
    if (this.navNextElement) {
      this.navNextElement.style.transform = `translateX(${paddingRight})`
    }
  }

  /**
   * 将所有slide元素的高度设置为"最高"的那个slide元素的高度
   */
  updateSlideItemHeightToMaxHeight(swiper) {

    const realItems = []
    this.querySelectorAll('.swiper-slide').forEach(slide => {
      realItems.push(slide.firstElementChild)
    })

    // 1. 计算最大高度
    const calculateMaxHeight = () => {
      let maxHeight = 0
      realItems.forEach(item => {
        item.style.height = 'auto'
        const height = item.getBoundingClientRect().height
        if (height > maxHeight) maxHeight = height
      })
      return maxHeight
    }

    // 2. 设置所有轮播项高度
    const unifySlideHeights = (height) => {
      this.querySelectorAll('.swiper-slide').forEach(slide => {
        slide.style.height = `${height}px`;
        slide.style.minHeight = `${height}px`;
      });

      realItems.forEach(item => {
        item.style.height = '100%'
      })

      // Swiper高度刷新机制
      swiper.updateAutoHeight();
    };

    unifySlideHeights(calculateMaxHeight());
  }

  /**
   * 将source的属性深度覆盖到target中
   * @param target
   * @param source
   * @return {*}
   */
  static deepMerge(target, source) {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        const sourceVal = source[key];
        const targetVal = target[key];

        // 双方都是纯对象且目标对象存在该属性时递归合并
        if (
          typeof sourceVal === 'object' &&
          sourceVal !== null &&
          !Array.isArray(sourceVal) &&
          target.hasOwnProperty(key) &&
          typeof targetVal === 'object' &&
          targetVal !== null &&
          !Array.isArray(targetVal)
        ) {
          SwiperComponent.deepMerge(targetVal, sourceVal);
        } else {
          target[key] = sourceVal;
        }
      }
    }
    return target;
  }
}
customElements.define('swiper-component', SwiperComponent)


/**
 * 原模版的slideshow的height-adapt有bug，开发一个新的slideshow（基于Swiper库实现）。
 */
class SwiperSlideshow extends HTMLElement {
  constructor() {
    super();
    this.isMobileMedia = window.matchMedia('(max-width: 767px)');
    this.onMediaChange = this.handleMediaChange.bind(this);
  }

  connectedCallback() {
    this.isMobileMedia.addEventListener('change', this.onMediaChange);
    this.initSwiper();
  }

  disconnectedCallback() {
    this.isMobileMedia.removeEventListener('change', this.onMediaChange);
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  handleMediaChange() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const oldPagination = this.swiperElement?.querySelector('.swiper-pagination');
    const oldPrev = this.swiperElement?.querySelector('.swiper-button-prev');
    const oldNext = this.swiperElement?.querySelector('.swiper-button-next');
    oldPagination?.remove();
    oldPrev?.remove();
    oldNext?.remove();

    this.initSwiper();
  }

  initSwiper() {
    if (this.swiper) return;

    this.swiperElement = this.querySelector('.swiper');

    const comp = this;
    const desktopStyle = this.dataset.layoutStyleDesktop || 'classic';
    const mobileStyle = this.dataset.layoutStyleMobile || 'classic';
    const isCardPeek = this.isMobileMedia.matches
      ? mobileStyle === 'card_peek'
      : desktopStyle === 'card_peek';

    const options = {
      loop: this.dataset.loop === 'true',
      slidesPerView: isCardPeek ? 'auto' : 1,
      centeredSlides: isCardPeek,
      spaceBetween: isCardPeek ? 18 : 0,
      autoHeight: isCardPeek ? false : true,
      lazy: true,
      watchSlidesProgress: isCardPeek,
      speed: 600,
      breakpoints: isCardPeek
        ? {
            0: {
              slidesPerView: 1.08,
              centeredSlides: true,
              spaceBetween: 12,
              autoHeight: false
            },
            768: {
              slidesPerView: 'auto',
              centeredSlides: true,
              spaceBetween: 18,
              autoHeight: false
            }
          }
        : {
            0: {
              slidesPerView: 1,
              centeredSlides: false,
              spaceBetween: 0,
              autoHeight: true
            },
            768: {
              slidesPerView: 1,
              centeredSlides: false,
              spaceBetween: 0,
              autoHeight: true
            }
          },
      on: {
        init: function () {
          comp.onSwiperReady();
        },
        slideChangeTransitionEnd: function (e) {
          comp.onSlideItemChanged(e.realIndex ?? e.activeIndex);
        },
        slideChangeTransitionStart: function () {
          comp.onSlideItemStartChange();
        }
      }
    };

    if (this.dataset.autoplay === 'true') {
      options.autoplay = {
        delay: parseInt(this.dataset.autoplaySpeed || '5') * 1000,
        disableOnInteraction: false
      };
    }

    const paginationElement = document.createElement('span');
    paginationElement.classList.add('swiper-pagination');
    this.swiperElement.appendChild(paginationElement);
    options.pagination = { el: paginationElement, clickable: true };

    const navElementPrev = document.createElement('span');
    navElementPrev.classList.add('swiper-nav-button', 'swiper-button-prev');
    this.swiperElement.appendChild(navElementPrev);

    const navElementNext = document.createElement('span');
    navElementNext.classList.add('swiper-nav-button', 'swiper-button-next');
    this.swiperElement.appendChild(navElementNext);

    options.navigation = { nextEl: navElementNext, prevEl: navElementPrev };

    this.swiper = new Swiper(this.swiperElement, options);
  }

  onSwiperReady() {
    this.onSlideItemChanged(this.swiper?.realIndex ?? 0);
    this.observeAutoHeight();
  }

  // autoHeight is measured once; on iOS lazy images / toolbar resizes leave the wrapper too short and crop the image
  observeAutoHeight() {
    this.heightObserver?.disconnect();
    if (!this.swiper) return;

    const refresh = () => {
      if (!this.swiper || this.swiper.destroyed) return;
      this.swiper.updateAutoHeight(0);
    };
    const refreshSoon = () => requestAnimationFrame(refresh);

    if (window.ResizeObserver) {
      this.heightObserver = new ResizeObserver(refreshSoon);
      this.swiperElement.querySelectorAll('.swiper-slide').forEach(slide => this.heightObserver.observe(slide));
    }

    this.swiperElement.querySelectorAll('.swiper-slide img').forEach(img => {
      if (!img.complete) img.addEventListener('load', refreshSoon, { once: true });
    });
    window.addEventListener('load', refreshSoon, { once: true });
    window.addEventListener('orientationchange', () => setTimeout(refresh, 300), { passive: true });
    refreshSoon();
  }

  onSlideItemStartChange() {
    this.swiperElement.querySelectorAll('.slideshow-item video-media').forEach(vm => {
      vm.pause();
    });
  }

  onSlideItemChanged(index) {
    const slides = Array.from(this.swiperElement.querySelectorAll('.swiper-slide'));
    const activeSlide = slides.find(slide => slide.classList.contains('swiper-slide-active'));
    const slideshowItem = activeSlide?.querySelector('.slideshow-item');

    if (!slideshowItem) return;

    if (slideshowItem.dataset.type === 'video') {
      let videoMedia = null;

      if (this.isMobileMedia.matches) {
        videoMedia = slideshowItem.querySelector('video-media.mobile-media');
        if (!videoMedia) {
          videoMedia = slideshowItem.querySelector('video-media:not(.mobile-media)');
        }
      } else {
        videoMedia = slideshowItem.querySelector('video-media:not(.mobile-media)');
      }

      videoMedia?.play();
    }
  }
}

if (!customElements.get('swiper-slideshow')) {
  customElements.define('swiper-slideshow', SwiperSlideshow);
}


class SwiperTestimonials extends HTMLElement {
  constructor() {
    super();
    this.isMobileMedia = window.matchMedia('(max-width: 767px)')
    this.isTabletMedia = window.matchMedia('(min-width: 768px) and (max-width: 1024px)')
    this.isDesktopMedia = window.matchMedia('(min-width: 1025px)')
    this.imageDisplayCountDesktop = parseInt(this.dataset.imageCountDesktop)
    this.imageDisplayCountTablet = parseInt(this.dataset.imageCountTablet)
    this.imageDisplayCountMobile = parseInt(this.dataset.imageCountMobile)

    this.brandContainer = this.querySelector('.testimonials__item-images');
    this.brandImages = Array.from(this.querySelectorAll('.testimonials__item-image'))
    this.brandImages.forEach(item => {
      item.addEventListener('click', this.onAuthorImageClick.bind(this))
    })

    this.currentOffset = 0
    this.offsetPadding = 10
    // last状态是为了监听resize事件时，重置状态
    this.lastSelectedIndex = 0
    this.lastDirection = 'next'
    this.lastPadding = this.offsetPadding

  }


  connectedCallback() {

    this.swiperElement = this.querySelector('.testimonials-text.swiper')

    const comp = this
    const options = {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      loop: true,
      on: {
        init: function () {
          comp.onSlideItemChanged(0, 'prev')
        },
        slideChangeTransitionEnd: function (e) {
        },
        slideChangeTransitionStart: function (e) {
          const dir = e.realIndex > e.previousRealIndex ? 'next' : 'prev'
          comp.onSlideItemChanged(e.realIndex, dir)
        }
      }
    }
    if (this.dataset.autoplay === 'true') {
      options.autoplay = {
        delay: parseInt(this.dataset.autoplaySpeed || '5') * 1000,
      }
    }

    let pagination = null
    let navigation = null

    // const paginationElement = document.createElement('span')
    // paginationElement.classList.add('swiper-pagination')
    // this.swiperElement.appendChild(paginationElement)
    // options.pagination = { el: ".swiper-pagination", clickable: true }

    // const navElementPrev = document.createElement('span')
    // navElementPrev.classList.add('swiper-nav-button')
    // navElementPrev.classList.add('swiper-button-prev')
    // this.appendChild(navElementPrev)

    // const navElementNext = document.createElement('span')
    // navElementNext.classList.add('swiper-nav-button')
    // navElementNext.classList.add('swiper-button-next')
    // this.appendChild(navElementNext)
    // options.navigation = { nextEl: navElementNext, prevEl: navElementPrev }


    this.swiper = new Swiper(this.swiperElement, options);

    this.initResizeListener()
  }

  initResizeListener() {
    const onWindowSizeChanged = theme.utils.debounce(() => {
      this.updateSlideItemHeightToMaxHeight(this.swiper)
      this.resetEnsureCurrentItemVisible()
    }, 300)
    const observer = new ResizeObserver(entries => {
      onWindowSizeChanged()
    });
    observer.observe(document.body);
  }

  onSlideItemChanged (index, dir) {
    this.brandImages.forEach(item => (item.classList.remove('current')))
    this.brandImages[index].classList.add('current')
    this.ensureCurrentItemVisible(this.brandImages[index], dir)
  }

  getRequiredOffset(elementRect, containerRect, padding, dir) {
    // 调整容器边界，考虑padding
    const paddedLeft = containerRect.left + padding
    const paddedRight = containerRect.right - padding

    // 如果元素完全在左侧
    if (elementRect.right <= paddedLeft) {
      return paddedLeft - elementRect.left
    }
    // 如果元素完全在右侧
    else if (elementRect.left >= paddedRight) {
      return paddedRight - elementRect.right
    }
    // 如果元素部分在左侧
    else if (elementRect.left < paddedLeft) {
      return paddedLeft - elementRect.left
    }
    // 如果元素部分在右侧
    else if (elementRect.right > paddedRight) {
      // 对于next方向，我们希望元素尽可能在右侧可见
      if (dir === 'next') {
        return paddedRight - elementRect.right
      }
      // 对于prev方向，我们希望元素尽可能在左侧可见
      else if (dir === 'prev') {
        return paddedLeft - elementRect.left
      }
    }
    return 0
  }

  resetEnsureCurrentItemVisible() {
    this.currentOffset = 0
    this.brandImages.forEach(item => {
      item.style.transform = `translateX(${this.currentOffset}px)`
    })

    setTimeout(() => {
      const item = this.brandImages.find(item => item.classList.contains('current'))
      this.ensureCurrentItemVisible(item, this.lastDirection)
    }, 500)

  }
  ensureCurrentItemVisible(item, dir) {

    const boxList = this.brandImages
    const padding = this.offsetPadding
    // 保存当前选择
    this.lastSelectedIndex = boxList.indexOf(item)
    this.lastDirection = dir
    this.lastPadding = padding

    const containerRect = this.brandContainer.getBoundingClientRect()
    const itemRect = item.getBoundingClientRect()
    let adjacentItem = null
    let adjacentItemRect = null

    // 获取相邻元素
    const index = boxList.indexOf(item)
    if (dir === 'next' && index < boxList.length - 1) {
      adjacentItem = boxList[index + 1]
      adjacentItemRect = adjacentItem.getBoundingClientRect()
    }
    else if (dir === 'prev' && index > 0) {
      adjacentItem = boxList[index - 1]
      adjacentItemRect = adjacentItem.getBoundingClientRect()
    }

    // 计算需要的偏移量
    let offset = 0

    // 首先检查当前元素是否完全可见（考虑padding）
    const itemOffset = this.getRequiredOffset(itemRect, containerRect, padding, dir)
    if (itemOffset !== 0) {
      offset = itemOffset
      // 如果当前元素被平移，确保相邻元素也可见（考虑padding）
      if (adjacentItem) {
        const adjacentOffset = this.getRequiredOffset(adjacentItemRect, containerRect, padding, dir)
        // 对于next方向，确保下一个元素在右侧可见
        if (dir === 'next' && adjacentOffset !== 0) {
          offset = adjacentOffset
        }
        // 对于prev方向，确保上一个元素在左侧可见
        else if (dir === 'prev' && adjacentOffset !== 0) {
          offset = adjacentOffset
        }
      }
    }
    // 如果当前元素已经可见，检查相邻元素（考虑padding）
    else if (adjacentItem) {
      offset = this.getRequiredOffset(adjacentItemRect, containerRect, padding, dir)
    }

    // 如果不需要移动，直接返回
    if (offset === 0) {
      return
    }

    // 计算新的总偏移量
    this.currentOffset += offset

    this.brandImages.forEach(item => {
      item.style.transform = `translateX(${this.currentOffset}px)`
    })
  }

  onAuthorImageClick (e) {
    const targetElement = e.currentTarget.closest('.testimonials__item-image');
    const targetIndex = parseInt(targetElement.dataset.index)
    const position = targetIndex - 1
    if (position >= 0) {
      this.swiper.slideToLoop(position)
    }
  }



  /**
   * 将所有slide元素的高度设置为"最高"的那个slide元素的高度
   */
  updateSlideItemHeightToMaxHeight(swiper) {

    const realItems = []
    swiper.el.querySelectorAll('.swiper-slide').forEach(slide => {
      realItems.push(slide.firstElementChild)
    })

    // 1. 计算最大高度
    const calculateMaxHeight = () => {
      let maxHeight = 0
      realItems.forEach(item => {
        item.style.height = 'auto'
        const height = item.getBoundingClientRect().height
        if (height > maxHeight) maxHeight = height
      })
      return maxHeight
    }

    // 2. 设置所有轮播项高度
    const unifySlideHeights = (height) => {
      swiper.el.querySelectorAll('.swiper-slide').forEach(slide => {
        slide.style.height = `${height}px`;
        slide.style.minHeight = `${height}px`;
      });

      realItems.forEach(item => {
        item.style.height = '100%'
      })

      // Swiper高度刷新机制
      swiper.updateAutoHeight();
    };

    unifySlideHeights(calculateMaxHeight());
  }
}
customElements.define('swiper-testimonials', SwiperTestimonials)


class VideoHeroV3 extends HTMLElement {
  constructor() {
    super();

    this.playAll = false;
    this.playBeforeSec = parseInt(this.dataset.autoPlayTime || 999);
    this.playBeforeSecMobile = parseInt(this.dataset.autoPlayTimeMobile || 999);
    this.enableScrollFollow = this.dataset.enableScrollFollow === 'true';

    this.isMobileMedia = window.matchMedia('(max-width: 767px)');
    this.onMediaQueryChange = this.mediaQueryChanged.bind(this);
    this.isMobileMedia.addEventListener('change', this.onMediaQueryChange);

    this.watchButton = this.querySelector('.button-watchvideo');
    this.onWatchButtonClick = this.openVideoModal.bind(this);
    this.watchButton?.addEventListener('click', this.onWatchButtonClick);

    this.playButton = this.querySelector('play-button');
    this.onPlayButtonStatusChanged = this.onPlayButtonPlayingChanged.bind(this);
    this.playButton?.addEventListener('playStatusChanged', this.onPlayButtonStatusChanged);

    this.videoMedia = this.querySelector('video-media');
    if (this.videoMedia) {
      this.onVideoPlayStartHandler = this.onVideoPlayStart.bind(this);
      this.onVideoPlayStopHandler = this.onVideoPlayStop.bind(this);
      this.onVideoProgressUpdatedHandler = this.onVideoProgressUpdated.bind(this);
      this.onVideoTimeUpdatedHandler = this.onVideoTimeUpdated.bind(this);

      this.videoMedia.addEventListener('playStart', this.onVideoPlayStartHandler);
      this.videoMedia.addEventListener('playStop', this.onVideoPlayStopHandler);
      this.videoMedia.addEventListener('videoProgress', this.onVideoProgressUpdatedHandler);
      this.videoMedia.addEventListener('timeupdate', this.onVideoTimeUpdatedHandler);
    }

    this.overlay = this.querySelector('.video-herov3-overlay');
    this.contentElement = this.querySelector('.content__text');

    this.overlayOpacity = parseFloat(this.overlay?.dataset.opacity);
    if (Number.isNaN(this.overlayOpacity)) {
      const cssOverlayOpacity = getComputedStyle(this).getPropertyValue('--overlay-opacity').trim();
      this.overlayOpacity = parseFloat(cssOverlayOpacity);
    }
    if (Number.isNaN(this.overlayOpacity)) {
      this.overlayOpacity = 0.3;
    }

    if (this.enableScrollFollow) {
      this.initScrollFollow();
    } else {
      this.initStaticMode();
    }
  }

initStaticMode() {
  this.classList.add('video-hero-v3--static');
  this.classList.remove('video-hero-v3--scroll-follow', 'play-all');

  if (this.scrollScene) {
    this.scrollScene.destroy(true);
    this.scrollScene = null;
  }

  if (this.timeline) {
    this.timeline.kill();
    this.timeline = null;
  }

  if (this.contentElement) {
    gsap.set(this.contentElement, {
      clearProps: 'transform',
      opacity: 1,
      visibility: 'visible',
      y: 0
    });
  }

  if (this.overlay) {
    gsap.killTweensOf(this.overlay);
    this.overlay.style.opacity = '';
    this.overlay.style.visibility = 'visible';
  }

  this.style.removeProperty('height');
  this.style.minHeight = '';
  this.style.overflow = 'hidden';
}

  initScrollFollow() {
    if (!this.contentElement || !this.overlay || !window.scrollMagicController || typeof ScrollMagic === 'undefined') {
      this.initStaticMode();
      return;
    }

    this.classList.add('video-hero-v3--scroll-follow');
    this.classList.remove('video-hero-v3--static');

    gsap.killTweensOf(this.contentElement);
    gsap.killTweensOf(this.overlay);

    this.timeline = gsap.timeline();

    this.timeline.fromTo(
      this.contentElement,
      { y: '100vh', opacity: 0 },
      {
        y: '50vh',
        opacity: 1,
        duration: 0.7,
        ease: 'power2.out'
      }
    );

    this.timeline.fromTo(
      this.overlay,
      { opacity: 0 },
      {
        opacity: this.overlayOpacity,
        duration: 0.7,
        ease: 'power2.out'
      },
      '<'
    );

    this.timeline.to(this.contentElement, {
      duration: 0.1,
      ease: 'none'
    });

    this.timeline.to(
      this.contentElement,
      {
        y: '-10vh',
        duration: 0.7,
        opacity: 0,
        ease: 'power2.out'
      }
    ).to(
      this.overlay,
      {
        opacity: 0,
        duration: 0.7,
        ease: 'power2.out'
      },
      '<'
    );

    this.scrollScene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0,
      duration: 1500
    })
      .setTween(this.timeline)
      .setPin(this)
      .addTo(window.scrollMagicController);
  }

  mediaQueryChanged() {
    const video = this.videoMedia?.querySelector('video');
    if (video) {
      const wasPlaying = !video.paused;
      video.load();
      if (wasPlaying) {
        video.play()?.catch(() => {});
      }
    }
  }

  getPlayer() {
    return this.videoMedia;
  }

  onPlayButtonPlayingChanged(e) {
    const isPlaying = e.detail.isPlaying;
    if (isPlaying) {
      this.getPlayer()?.play();
    } else {
      this.getPlayer()?.pause();
    }
  }

  onVideoPlayStart() {
    this.playButton?.setPlaying(true);
  }

  onVideoPlayStop() {
    this.playButton?.setPlaying(false);
  }

  onVideoProgressUpdated(e) {
    const percent = e.detail.progress;
    this.playButton?.setProgress(percent);
  }

  onVideoTimeUpdated(e) {
    if (this.playAll) return;

    const sec = this.isMobileMedia.matches ? this.playBeforeSecMobile : this.playBeforeSec;
    if (e.detail.currentTime >= sec) {
      this.getPlayer()?.replay();
    }
  }

  onPlayButtonClick() {
    this.playAll = true;
    this.classList.add('play-all');
  }

  openVideoModal() {
    if (!this.getPlayer()) return;

    this.modal = document.createElement('div');
    this.modal.className = 'video-modal';
    this.modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    `;

    const closeButton = document.createElement('div');
    closeButton.className = 'video-modal-close';
    closeButton.style.cssText = `
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      z-index: 10000;
      color: white;
      font-size: 30px;
      text-align: center;
      line-height: 40px;
    `;
    closeButton.innerHTML = '×';
    closeButton.addEventListener('click', this.closeVideoModal.bind(this));

    const videoContainer = document.createElement('div');
    videoContainer.className = 'video-container';
    videoContainer.style.cssText = `
      width: 90%;
      max-width: 1200px;
      position: relative;
    `;

    const videoTemplate = this.querySelector('template[video]');
    if (!videoTemplate) return;

    const videoClone = videoTemplate
      .cloneNode(true)
      .content
      .querySelector('video');

    videoClone.style.cssText = `
      width: 100%;
      height: auto;
      display: block;
      max-height: 90vh;
    `;

    videoClone.controls = true;
    videoClone.muted = false;

    videoContainer.appendChild(videoClone);
    this.modal.appendChild(videoContainer);
    this.modal.appendChild(closeButton);
    document.body.appendChild(this.modal);
    document.body.style.overflow = 'hidden';

    const playPromise = videoClone.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        videoClone.controls = true;
      });
    }
  }

  closeVideoModal() {
    if (!this.modal) return;

    const video = this.modal.querySelector('video');
    if (video) {
      video.pause();
    }

    this.modal.remove();
    this.modal = null;
    document.body.style.overflow = '';
  }

  disconnectedCallback() {
    this.isMobileMedia?.removeEventListener('change', this.onMediaQueryChange);

    this.watchButton?.removeEventListener('click', this.onWatchButtonClick);
    this.playButton?.removeEventListener('playStatusChanged', this.onPlayButtonStatusChanged);

    if (this.videoMedia) {
      this.videoMedia.removeEventListener('playStart', this.onVideoPlayStartHandler);
      this.videoMedia.removeEventListener('playStop', this.onVideoPlayStopHandler);
      this.videoMedia.removeEventListener('videoProgress', this.onVideoProgressUpdatedHandler);
      this.videoMedia.removeEventListener('timeupdate', this.onVideoTimeUpdatedHandler);
    }

    if (this.scrollScene) {
      this.scrollScene.destroy(true);
      this.scrollScene = null;
    }

    if (this.timeline) {
      this.timeline.kill();
      this.timeline = null;
    }

    if (this.modal) {
      this.closeVideoModal();
    }
  }
}
customElements.define('video-hero-v3', VideoHeroV3);


class VideoHeroV4 extends HTMLElement {
  constructor() {
    super()

    this.startPlayOnVisiblePercent = parseFloat(this.dataset.playOnVisiblePercent)
    this.contentShowOnVideoEnd = this.dataset.contentShowOnVideoEnd === 'true'
    this.contentShowOnVideoInSec = null
    if (this.dataset.contentShowOnVideoInSec) {
      this.contentShowOnVideoInSec = parseFloat(this.dataset.contentShowOnVideoInSec)
    }
    this.contentShowOnVideoInSecAnimated = false

    this.overlay = this.querySelector('.video-overlay')
    this.videoContent = this.querySelector('.video-content')

    if (this.contentShowOnVideoEnd || this.contentShowOnVideoInSec > 0) {
      this.overlay.style.opacity = 0
      this.videoContent.style.opacity = 0
    }

    this.isMobileMedia = window.matchMedia('(max-width: 767px)')
    this.isMobileMedia.addEventListener('change', (e) => {
      this.mediaQueryChanged(e.matches)
    })

    this.videoMedia = this.querySelector('video-media')

    if (this.contentShowOnVideoEnd) {
      this.videoMedia.addEventListener('playComplete', this.onVideoEnd.bind(this))
    } else if (this.contentShowOnVideoInSec) {
      this.videoMedia.addEventListener('timeupdate', this.onVideoTimeUpdate.bind(this))
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (entry.isIntersecting) {
        const visibleHeight = entry.intersectionRect.height;
        const elHeight = entry.boundingClientRect.height;
        
        // 处理元素高度为0的情况（防止除以0）
        const visiblePercent = elHeight > 0 ? visibleHeight / elHeight : 0;
        
        // 考虑元素被部分遮挡的情况
        const isFullyVisible = entry.intersectionRatio === 1;
        const isVisibleEnough = visiblePercent >= this.startPlayOnVisiblePercent;
        const isCoveringViewport = visibleHeight >= window.innerHeight;
        
        if (isFullyVisible || isVisibleEnough || isCoveringViewport) {
          this.startPlayVideo();
          observer.disconnect();
        }
      }
    }, {
      threshold: [0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1], // 自定义计算可见区域
      rootMargin: '0px' // 可扩展监控边界
    })
    observer.observe(this)
  }

  mediaQueryChanged(isMobile) {
    const video = this.videoMedia?.querySelector('video')
    if (video) {
      video.load()
      if (this.played === true) {
        video.play()?.catch(() => {})
      }
    }
  }

  getPlayer() {
    return this.videoMedia
  }

  startPlayVideo() {
    this.played = true
    this.getPlayer()?.play()
  }

  onVideoEnd() {
    if (this.contentShowOnVideoEnd) {
      gsap.fromTo(this.overlay, { opacity: 0 }, { opacity: 1, duration: .3 })
      gsap.fromTo(this.videoContent, { opacity: 0 }, { opacity: 1, duration: .3 })
    }
  }

  onVideoTimeUpdate(e) {
    if (this.contentShowOnVideoInSecAnimated) return
    if (e.detail.currentTime >= this.contentShowOnVideoInSec) {
      this.contentShowOnVideoInSecAnimated = true
      gsap.fromTo(this.overlay, { opacity: 0 }, { opacity: 1, duration: .3 })
      gsap.fromTo(this.videoContent, { opacity: 0 }, { opacity: 1, duration: .3 })
    }
  }
}
customElements.define('video-hero-v4', VideoHeroV4);


class PinAnimeBanner extends HTMLElement {
  constructor() {
    super();
    const timeline = gsap.timeline()
    timeline.fromTo(this.querySelectorAll('.pab__content-text-item-group.group-1'), {
      y: 0,
      opacity: 1
    }, {
      opacity: 0,
      y: -20,
      // transformOrigin: "center top",
      // force3D: true, // 启用3D加速
      // snap: { scaleY: 0.1 }, // 限制缩放步进值
      ease: "power2.inOut",
      delay: 0.05
    })
    timeline.fromTo(this.querySelectorAll('.pab__content-text-item-group.group-2'), {
      y: -20,
      opacity: 0
    }, {
      opacity: 1,
      y: 0,
      // transformOrigin: "center bottom",
      // force3D: true, // 启用3D加速
      // snap: { scaleY: 0.1 }, // 限制缩放步进值
      ease: "power2.inOut"
    }, '<')

    new ScrollMagic.Scene({triggerElement: this, triggerHook: 0, duration: 10})
      .setTween(timeline)
      .setPin(this)
      .addTo(window.scrollMagicController)
  }

  connectedCallback() {
  }
}
customElements.define('pin-anime-banner', PinAnimeBanner)


class PinWipes extends HTMLElement {
  constructor() {
    super()
    this.isMobileMedia = window.matchMedia(theme.config.mediaQuerySmall)
    this.isMobileMedia.addEventListener('change', this.onMediaQueryChanged.bind(this))

    this.horizontalOnMobile = this.dataset.horizontalOnMobile === 'true'

    this.wipes = this.querySelectorAll('.wipe__item')
    this.pages = Array.from(this.querySelectorAll('.wipe__pagination li') || [])
    this.initWipes()
    this.updateActivePage(0)
  }

  onMediaQueryChanged() {
    if (this.horizontalOnMobile === true) {
      // 保留当前滚动位置
      const scrollProgress = this.scrollMagicScene ? this.scrollMagicScene.progress() : 0;
      
      // 清除现有动画
      if (this.scrollMagicScene) this.scrollMagicScene.destroy(true);
      if (this.timeline) this.timeline.kill();
      
      // 重建动画
      this.initWipes();
      
      // 恢复滚动位置
      if (this.scrollMagicScene) {
        this.scrollMagicScene.progress(scrollProgress);
      }
    }
  }

  initWipes() {
    const items = Array.from(this.wipes)
    if (items.length <= 1) return

    let moveDir = 'y'
    if (this.horizontalOnMobile === true && this.isMobileMedia.matches) {
      moveDir = 'x'
    }

    this.timeline = gsap.timeline()
    let duration = 0
    for (let i = items.length - 1; i > 0; i--) {
      const currentIndex = items.length - i - 1
      const fromOpt = {}
      fromOpt[moveDir] = '0%'
      const toOpt = {
        delay: 0, 
          duration: 1,
          onReverseComplete: () => {
            this.updateActivePage(currentIndex)
          },
          onStart: () => {
            this.updateActivePage(currentIndex)
          },
          onComplete: () => {
            this.updateActivePage(currentIndex + 1)
          }
      }
      toOpt[moveDir] = '-100%'
      this.timeline.fromTo(items[i], fromOpt, toOpt)
      duration += 1
    }

    this.scrollMagicScene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0,
      duration: (duration * 100) + '%'
    })
    .setPin(this)
    .setTween(this.timeline)
    .addTo(window.scrollMagicController)
  }

  updateActivePage(index) {
    for (let i = 0; i < this.pages.length; i++) {
      this.pages[i].classList.remove('active')
      if (index === i) {
        this.pages[i].classList.add('active')
      }
    }
  }

  connectedCallback() {

  }
}
customElements.define('pin-wipes', PinWipes)


class TabTextWithImage extends HTMLElement {
  constructor() {
    super()

    this.imageSplideElement = this.querySelector('.ttwi__image-container .splide')
    this.tabs = Array.from(this.querySelectorAll('.ttwi__tabs .ttwi__tab'))
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.onTabItemClick.bind(this))
    })

    this.tabContentSplideElement = this.querySelector('.ttwi__tab-contents .splide')
  }

  connectedCallback() {
    this.imageSplide = new Splide(this.imageSplideElement, {
      arrows: false,
      pagination: false,
      drag: false,
      perPage: 1
    })
    this.imageSplide.mount()

    this.tabContentSplide = new Splide(this.tabContentSplideElement, {
      arrows: false,
      pagination: false,
      drag: false,
      perPage: 1
    })
    this.tabContentSplide.mount()
  }

  onTabItemClick(e) {
    const tab = e.target.closest('.ttwi__tab')
    if (tab) {
      this.tabs.forEach(tab => tab.classList.remove('active'))
      tab.classList.add('active')
      const index = this.tabs.indexOf(tab)
      this.imageSplide.go(index)
      this.tabContentSplide.go(index)
    }
  }
}
customElements.define('tab-text-with-image', TabTextWithImage)


class MagicHeading extends HTMLElement {
  constructor() {
    super();

    this.texts = []
    try {
      this.texts = JSON.parse(this.querySelector('script[data-texts]')?.textContent)
    } catch (ignore) {
    }
  }

  connectedCallback() {
    const magicHeading = this.querySelector('.magic-heading')
    if (!magicHeading || this.texts.length === 0) return;
    
    let magicHeadingText = magicHeading.textContent;
    const sortedTexts = [...this.texts].sort((a, b) => b.content.length - a.content.length);
    const replacements = new Map();
    sortedTexts.forEach(text => {
      if (!text) return;
      const marker = `__${Math.random().toString(36).substr(2, 9)}__`;
      let newline = ''
      if (text.newline === true) {
        newline = '<br>'
      }
      replacements.set(marker, `${newline}<span class="magic-block block-${text.blockId}">${text.content}</span>`);
      const regex = new RegExp(escapeRegExp(text.content), 'g');
      magicHeadingText = magicHeadingText.replace(regex, marker);
    })
    replacements.forEach((value, key) => {
      magicHeadingText = magicHeadingText.replace(new RegExp(key, 'g'), value);
    });
    magicHeading.innerHTML = magicHeadingText;
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  }
}
customElements.define('magic-heading', MagicHeading)


class BannerRichText extends HTMLElement {
  constructor() {
    super()

    const content = this.querySelector('template[data-content]').content.firstElementChild?.cloneNode(true)

    const map = {}
    this.rows = Array.from(content.querySelectorAll('.brt__content-row'))
    for (const row of this.rows) {
      const arr = map[row.dataset.boxId] || []
      arr.push(row)
      map[row.dataset.boxId] = arr
    }


    for (const boxId of Object.keys(map)) {
      const rows = map[boxId]

      const contentContainer = document.createElement('div')
      contentContainer.classList.add(`box-layout-${boxId}`, 'brt__content')
      this.appendChild(contentContainer)

      const box = document.createElement('div')
      box.classList.add('brt__content-box')
      contentContainer.appendChild(box)

      const boxSettings = content.querySelector(`.box-tmp.box-${boxId}`)
      if (boxSettings && boxSettings.dataset.animeDirection) {
        box.classList.add('use-show-anime')
        box.setAttribute('data-anime-direction', boxSettings.dataset.animeDirection)
        boxSettings.remove()
      }

      for (const row of rows) {
        box.appendChild(row)
      }
    }

    this.initShowAnimation()
  }

  initShowAnimation() {
    const animeEls = Array.from(this.querySelectorAll('.use-show-anime'))
    if (animeEls.length > 0) {
      const timeline = gsap.timeline()
      animeEls.forEach(el => {
        const direction = el.dataset.animeDirection || 'toUp'
        let xy = '', from = '', to = ''
        switch (direction) {
          case 'toUp':
            xy = 'y'
            from = 100
            to = 0
            break
          case 'toDown':
            xy = 'y'
            from = -100
            to = 0
            break
          case 'toLeft':
            xy = 'x'
            from = 100
            to = 0
            break
          case 'toRight':
            xy = 'x'
            from = -100
            to = 0
            break
        }
        const fromOpt = { opacity: 0 }
        fromOpt[xy] = from
        const toOpt = { opacity: 1 }
        toOpt[xy] = to
        timeline.fromTo(el, fromOpt, toOpt, 0)
      })
      new ScrollMagic.Scene({triggerElement: this, triggerHook: 0, duration: 700})
        .setTween(timeline)
        .setPin(this)
        .addTo(window.scrollMagicController)
    }
  }

  connectedCallback() {

  }
}
customElements.define('banner-rich-text', BannerRichText)


class ImageAnimateWithOverlay extends HTMLElement {
  constructor() {
    super()

    const section = this.querySelector('.iawo-section')
    const blocks = Array.from(section.querySelectorAll('.iawo-content-block'))
    const timeline = gsap.timeline()

    /*
    动画效果：
    文字分两部分，一部分没有.with-overlay，另一部分有.with-overlay。
    没有.with-overlay的文字只是单纯的动画，有.with-overlay的文字和overlay元素的渐变有关联。

    下面的代码逻辑换算成下面的比较容易理解：
    timeline.add('marker-1')
    timeline.to('.box1', { y: -100 })

    timeline.to('.box2', { x: 100 }, 'marker-1')
    timeline.add('marker-2')
    timeline.to('.box2', { y: -100 })

    timeline.to('.box3.with-overlay', { x: 100 }, 'marker-2')
    timeline.add('marker-3')
    timeline.to('.box3.with-overlay', { y: -100 }, 'overlayStart')

    timeline.to('.box4', { x: 100 }, 'marker-3')


    timeline.fromTo('.overlay', { opacity: 1 }, { opacity: 0, duration: timeline.duration() * 0.8 }, 'overlayStart')
    */
    let overlayStartPosition
    for (let i = 0; i < blocks.length; i++) {
      const el = blocks[i]
      if (i === 0) {
        timeline.add('block_' + i)
        timeline.to(el, { opacity: 0, y: -50 })
      } else if (i === blocks.length - 1) {
        timeline.to(el, { opacity: 1 }, 'block_' + (i - 1))
      } else {
        const withOverlay = el.classList.contains('with-overlay')
        if (!overlayStartPosition) {
          overlayStartPosition = withOverlay ? 'overlayStart' : undefined
        }
        timeline.to(el, { opacity: 1 }, 'block_' + (i - 1))
        timeline.add('block_' + i)
        const opt = { opacity: 0 }
        if (!withOverlay) {
          opt.y = -50
        }
        timeline.to(el, opt, overlayStartPosition)
      }
    }

    const overlay = section.querySelector('.iawo-overlay')

    // overlay透明度变化从第一个.with-overlay元素的动画（透明度1>0）开始执行，贯穿整个timeline
    timeline.fromTo(
      overlay,
      {
        opacity: parseFloat(this.dataset.opacityStart)
      },
      { 
        opacity: parseFloat(this.dataset.opacityEnd),
        duration: timeline.duration() * 0.8
      },
      overlayStartPosition
    );


    new ScrollMagic.Scene({triggerElement: section, triggerHook: 0, duration: '100%'})
      .setTween(timeline)
      .setPin(section)
      .addTo(window.scrollMagicController)
  }

  connectedCallback() {

  }
}

customElements.define('image-animate-with-overlay', ImageAnimateWithOverlay)


/**
 * see snippets/slider-component-options.liquid
 * see theme.css slider-component
 */
class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.sliderComponentContainer = document.createElement('div')
    this.sliderComponentContainer.classList.add('slider-component-container')
    this.appendChild(this.sliderComponentContainer)

    this.sliderElement = this.querySelector('.splide')
    this.sliderComponentContainer.appendChild(this.sliderElement)

    // 合并所有的配置项
    const optionArray = []
    this.querySelectorAll('script[data-slider-options]').forEach(sc => {
      optionArray.push(JSON.parse(sc.textContent))
    })
    let tmp = {}
    for (let i = 0; i < optionArray.length; i++) {
      tmp = theme.utils.deepMerge(tmp, optionArray[i])
    }
    this.customSliderOptions = tmp

    this.sliderOptions = theme.utils.deepMerge({
      enableMobile: true,
      enableDesktop: true,
      pageBottom: true
    }, this.customSliderOptions)
    this.enableArrows = this.sliderOptions.arrows
    this.sliderOptions.arrows = false

    if (this.enableArrows) {
      this.createCustomArrows()
    }
    this.initSlider()
    this.initSlideItemHeight()
  }

  connectedCallback() {
    
  }

  onSliderReady() {
    this.updateArrowStates()
  }

  initSlider() {
    this.slider = new Splide(this.sliderElement, this.sliderOptions)
    this.slider.on('ready', this.onSliderReady.bind(this))
    this.slider.on('move', () => this.updateArrowStates());
    this.slider.mount()
  }

  updateArrowStates() {
    const splide = this.slider;
    // 处理上一个箭头状态
    const isStart = splide.index <= 0;
    const prevDisabled = isStart && !splide.options.rewind;

    this.prevArrows?.forEach(item => (item.disabled = prevDisabled))
    
    // 处理下一个箭头状态
    const isEnd = splide.index >= splide.Components.Controller.getEnd();
    const nextDisabled = isEnd && !splide.options.rewind;
    this.nextArrows?.forEach(item => (item.disabled = nextDisabled))
  }

  createCustomArrows() {
    // 创建箭头容器
    this.arrowsContainer = document.createElement('div');
    this.arrowsContainer.className = 'custom-splide-arrows';
    
    // 创建上一个箭头按钮
    const prevArrow = document.createElement('button');
    prevArrow.className = 'custom-splide-arrow custom-splide-arrow--prev';
    prevArrow.setAttribute('aria-label', 'Previous slide');
    
    // 创建下一个箭头按钮
    const nextArrow = document.createElement('button');
    nextArrow.className = 'custom-splide-arrow custom-splide-arrow--next';
    nextArrow.setAttribute('aria-label', 'Next slide');
    
    // 添加箭头图标（可以根据你的需求修改）
    if (this.dataset.navIcon) {
      const prevImg = document.createElement('img');
      prevImg.src = this.dataset.navIcon;
      prevImg.alt = 'Previous';
      prevArrow.appendChild(prevImg);
      
      const nextImg = document.createElement('img');
      nextImg.src = this.dataset.navIcon;
      nextImg.alt = 'Next';
      nextImg.style.transform = 'scaleX(-1)';
      nextArrow.appendChild(nextImg);
    } else {
      // 如果没有指定图标，使用简单文本
      prevArrow.innerHTML = `
      <svg class="{{ class }}" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path>
      </svg>
      `
      nextArrow.innerHTML = `
      <svg class="{{ class }}" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path>
      </svg>
      `
    }
    
    // 将箭头添加到容器
    this.arrowsContainer.appendChild(prevArrow);
    this.arrowsContainer.appendChild(nextArrow);

    this.nextArrows = [nextArrow]
    this.prevArrows = [prevArrow]

    this.sliderComponentContainer.appendChild(this.arrowsContainer);

    const navContainer = this.closest('.shopify-section').querySelector('.section-title-container .swiper-nav-button-container');
    if (navContainer) {
      navContainer.appendChild(this.arrowsContainer.cloneNode(true));
      this.nextArrows.push(navContainer.querySelector('.custom-splide-arrow--next'))
      this.prevArrows.push(navContainer.querySelector('.custom-splide-arrow--prev'))
    }

    this.prevArrows.forEach(item => item.addEventListener('click', () => this.slider.go('<')))
    this.nextArrows.forEach(item => item.addEventListener('click', () => this.slider.go('>')))
  }

  initSlideItemHeight() {
    // sameHeight配置，使每个slide item的高度统一的处理代码
    if (this.sliderOptions.sameHeight) {
      const onWindowSizeChanged = theme.utils.debounce(() => {
        this.updateSlideItemHeightToMaxHeight()
      }, 300)

      const observer = new ResizeObserver(entries => {
        onWindowSizeChanged()
      });
      observer.observe(document.body);
    }
  }

   /**
   * 将所有slide元素的高度设置为"最高"的那个slide元素的高度
   */
  updateSlideItemHeightToMaxHeight() {

    const slideItems = this.sliderElement.querySelectorAll('.splide__slide')
    const realItems = []
    slideItems.forEach(slide => {
      realItems.push(slide.firstElementChild)
    })

    // 1. 计算最大高度
    const calculateMaxHeight = () => {
      let maxHeight = 0
      realItems.forEach(item => {
        item.style.height = 'auto'
        const height = item.getBoundingClientRect().height
        if (height > maxHeight) maxHeight = height
      })
      return maxHeight
    }

    // 2. 设置所有轮播项高度
    const unifySlideHeights = (height) => {
      slideItems.forEach(slide => {
        slide.style.height = `${height}px`;
        slide.style.minHeight = `${height}px`;
      });

      realItems.forEach(item => {
        item.style.height = '100%'
      })
    };

    unifySlideHeights(calculateMaxHeight());
  }

  onPlayButtonClick(e) {
    e.target.closest('.slider-component__item-image')?.querySelector('video-media')?.togglePlay()
  }
}
customElements.define('slider-component', SliderComponent)


class VideoWithTexts extends HTMLElement {
  constructor() {
    super()

    this.contentContainer = this.querySelector('.vwts__content-container')
    this.videoContainer = this.querySelector('.vwts__video-container')
    this.splideElement = this.videoContainer.querySelector('.splide')
    this.splideListElement = this.splideElement.querySelector('.splide__list')

    this.tabList = this.querySelector('.vwts__video-tab-list')
    this.tabIndicator = this.tabList.querySelector('.vwts__video-tab-indicator')
    this.tabItems = Array.from(this.tabList.querySelectorAll('.vwts__video-tab-name'))
    this.tabItems.forEach(item => item.addEventListener('click', this.onTabItemClick.bind(this)))

    const content = this.querySelector('template[data-content]').content.firstElementChild?.cloneNode(true)
    const contents = Array.from(content.querySelectorAll('.vwts__content'))

    let rowContainer, colContainer
    for (const contentEl of contents) {
      const type = contentEl.dataset.type
      if (type === 'row') {
        rowContainer = contentEl
        colContainer = null
        this.contentContainer.appendChild(rowContainer)
      } else if (type === 'col') {
        colContainer = contentEl
        rowContainer?.appendChild(colContainer)
        rowContainer?.setAttribute('data-has-col', true)
      } else if (type === 'video') {
        contentEl.classList.add('splide__slide')
        this.splideListElement.appendChild(contentEl)
      } else {
        const box = colContainer || rowContainer
        box?.appendChild(contentEl)
      }
    }

    this.splideItems = Array.from(this.splideElement.querySelectorAll('.splide__slide'))

    const enableSlideOnDesktop = this.videoContainer.classList.contains('tab')
    const enableSlideOnMobile = this.videoContainer.classList.contains('tab-mobile')
    this.videoSplide = new Splide(this.splideElement, {
      perPage: 1,
      pagination: false,
      arrows: false,
      mediaQuery: 'min',
      breakpoints: {
        0: {
          perPage: 1,
          destroy: !enableSlideOnMobile
        },
        768: {
          perPage: 1,
          destroy: !enableSlideOnDesktop
        }
      }
    })
    this.videoSplide.on('move', (newIndex, prevIndex, destIndex) => {
      this.onSlideIndexChanged(destIndex, prevIndex)
    })
    this.videoSplide.on('ready', () => {
      this.updateActiveTab(0)
    })
    this.videoSplide.mount()


    // 为视频添加ended事件监听
    this.splideItems.forEach(item => {
      item.querySelector('video-media')?.addEventListener('playComplete', this.onVideoEnded.bind(this))
    })
  }

  connectedCallback() {

  }

  updateActiveTab(index) {
    let left = 0
    for (let i = 0; i < index; i++) {
      left += this.tabItems[i].getBoundingClientRect().width
    }
    const width = this.tabItems[index].getBoundingClientRect().width
    this.tabIndicator.style.width = `${width}px`
    this.tabIndicator.style.left = `${left}px`
  }

  onTabItemClick(e) {
    const index = this.tabItems.indexOf(e.currentTarget)
    this.videoSplide.go(index)
  }

  onSlideIndexChanged(index, prevIndex) {
    this.updateActiveTab(index)
    this.splideItems[prevIndex].querySelector('video-media')?.pause()
    this.splideItems[index].querySelector('video-media')?.replay()
  }

  onVideoEnded() {
    if (this.dataset.autoNext === 'true') {

      if (this.videoSplide.index === this.videoSplide.length - 1) {
        this.videoSplide.go(0)
      } else {
        this.videoSplide.go('>')
      }
    }
  }
}
customElements.define('video-with-texts', VideoWithTexts)


class PuzzleComp extends HTMLElement {
  constructor() {
    super()
    this.desktopAutoAdjustWidth = this.dataset.desktopAutoAdjustWidth === 'true'
    this.desktopStyle = this.dataset.desktopStyle
    this.desktopOriginWidth = parseInt(this.dataset.desktopWidth)
    this.desktopOriginHeight = parseInt(this.dataset.desktopHeight)
    this.mobileAutoAdjustWidth = this.dataset.mobileAutoAdjustWidth === 'true'
    this.mobileStyle = this.dataset.mobileStyle
    this.mobileOriginWidth = parseInt(this.dataset.mobileWidth)
    this.mobileOriginHeight = parseInt(this.dataset.mobileHeight)

    this.items = Array.from(this.querySelectorAll('.puzzle__item'))
    this.mobileQuery = window.matchMedia(theme.config.mediaQuerySmall)

    window.addEventListener('resize', theme.utils.throttle(this.adjustContainerWithPadding.bind(this)))
    this.adjustContainerWithPadding()
  }

  connectedCallback() {
    
  }

  /**
   * 响应式调整容器及其内部元素
   */
  adjustContainerWithPadding() {
    let container = this
    let padding = 0
    let media, puzzleStyle, originalWidth, originalHeight


    const reset = () => {
      // 恢复原始尺寸
      this.style.width = originalWidth == 0 ? '100%' : originalWidth + 'px';
      this.style.height = puzzleStyle == 'grid' ? 'auto' : originalHeight + 'px';
      
      this.items.forEach(child => {
        if (puzzleStyle == 'puzzle') {
          child.style.left = child.dataset[media + 'Left'] + 'px'
          child.style.top = child.dataset[media + 'Top'] + 'px'
          child.style.width = child.dataset[media + 'Width'] + 'px'
          child.style.height = child.dataset[media + 'Height'] + 'px'
        } else {
          child.style.left = 'unset'
          child.style.top = 'unset'
          child.style.width = '100%'
          child.style.height = 'auto'
        }
      });
    }

    if (this.mobileQuery.matches) {
      media = 'mobile'
      puzzleStyle = this.mobileStyle
      originalWidth = this.mobileOriginWidth
      originalHeight = this.mobileOriginHeight
      if (!this.mobileAutoAdjustWidth) {
        return reset()
      }
    } else {
      media = 'desktop'
      puzzleStyle = this.desktopStyle
      originalWidth = this.desktopOriginWidth
      originalHeight = this.desktopOriginHeight
      if (!this.desktopAutoAdjustWidth) {
        return reset()
      }
    }
    

    // 获取视口宽度
    const viewportWidth = this.parentElement.getBoundingClientRect().width;
    
    // 检查是否需要调整（考虑间距）
    if (viewportWidth < originalWidth + 2 * padding) {
        // 计算可用宽度（视口宽度减去左右间距）
        const availableWidth = viewportWidth - 2 * padding;
        
        // 确保可用宽度不小于0
        const effectiveWidth = Math.max(availableWidth, 0);
        
        // 计算缩放比例（基于可用宽度）
        const scale = effectiveWidth / originalWidth;
        
        // 调整容器尺寸（宽度减去间距）
        container.style.width = `${effectiveWidth}px`;
        container.style.height = `${originalHeight * scale}px`;
        
        // 调整子元素
        this.items.forEach(child => {
          const originalLeft = parseFloat(child.dataset[media + 'Left']);
          const originalTop = parseFloat(child.dataset[media + 'Top']);
          const originalWidth = parseFloat(child.dataset[media + 'Width']);
          const originalHeight = parseFloat(child.dataset[media + 'Height']);
          
          child.style.left = `${originalLeft * scale}px`;
          child.style.top = `${originalTop * scale}px`;
          child.style.width = `${originalWidth * scale}px`;
          child.style.height = `${originalHeight * scale}px`;
        })
    } else {
      reset()
    }
  }
}
customElements.define('puzzle-comp', PuzzleComp)


class SpiralDistribution extends HTMLElement {
  constructor() {
    super()
    this.isMobileQuery = window.matchMedia(theme.config.mediaQuerySmall);
    this.isDesignMode = this.hasAttribute('shopify-design-mode')
    this.designPoint = this.dataset.designPoint
    this.icons = Array.from(this.querySelectorAll('.image-icon'))

    this.icons.forEach(item => {
      item.style.left = '50%';
      item.style.top = '50%';
      item.style.opacity = '0';
      item.style.transform = 'translate(-50%, -50%) scale(1) rotate(0deg)';
    });

    if (this.isDesignMode) {
      this.initImageIconsForDesignMode()
    } else {
      this.initImageIcons()
    }
  }

  initImageIcons() {

    const masterTimeline = gsap.timeline();
    
    let pointXStart = 'pointXStart';
    let pointYStart = 'pointYStart';
    let widthStart = 'widthStart';
    let heightStart = 'heightStart';
    let opacityStart = 'opacityStart';
    let rotateStart = 'rotateStart'

    let pointX = 'pointX';
    let pointY = 'pointY';
    let width = 'width';
    let height = 'height';
    let opacity = 'opacity';
    let rotate = 'rotate'
    
    if (this.isMobileQuery.matches) {
      pointXStart = 'pointXMobileStart';
      pointYStart = 'pointYMobileStart';
      widthStart = 'widthMobileStart';
      heightStart = 'heightMobileStart';
      opacityStart = 'opacityMobileStart'
      rotateStart = 'rotateMobileStart'

      pointX = 'pointXMobile';
      pointY = 'pointYMobile';
      width = 'widthMobile';
      height = 'heightMobile';
      opacity = 'opacityMobile'
      rotate = 'rotateMobile'
    }
    
    // 为每个图标创建动画并添加到时间线
    this.icons.forEach(item => {
      masterTimeline.fromTo(item, {
        opacity: parseFloat(item.dataset[opacityStart]) / 100.0,
        left: `${item.dataset[pointXStart]}%`,
        top: `${item.dataset[pointYStart]}%`,
        width: `${item.dataset[widthStart]}px`,
        height: `${item.dataset[heightStart]}px`,
        rotate: item.dataset[rotateStart],
      }, {
        opacity: parseFloat(item.dataset[opacity]) / 100.0,
        left: `${item.dataset[pointX]}%`,
        top: `${item.dataset[pointY]}%`,
        width: `${item.dataset[width]}px`,
        height: `${item.dataset[height]}px`,
        rotate: item.dataset[rotate],
        ease: "none",
        transformOrigin: "center center"
      }, 0); // 所有动画同时开始
    });
    
    // 创建ScrollMagic场景
    new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.6,
      duration: '70%'
    })
    .setTween(masterTimeline)
    .addTo(window.scrollMagicController);

  }

  initImageIconsForDesignMode() {
    let suffix = this.designPoint == 'start' ? 'Start' : ''
    let pointX = 'pointX' + suffix
    let pointY = 'pointY' + suffix
    let width = 'width' + suffix
    let height = 'height' + suffix
    let opacity = 'opacity' + suffix
    let rotate = 'rotate' + suffix
    if (this.isMobileQuery.matches) {
      pointX = 'pointXMobile' + suffix
      pointY = 'pointYMobile' + suffix
      width = 'widthMobile' + suffix
      height = 'heightMobile' + suffix
      opacity = 'opacityMobile' + suffix
      rotate = 'rotateMobile' + suffix
    }
    this.icons.forEach(item => {
      item.style.opacity = parseFloat(item.dataset[opacity]) / 100.0
      item.style.left = `${item.dataset[pointX]}%`
      item.style.top = `${item.dataset[pointY]}%`
      item.style.width = `${item.dataset[width]}px`
      item.style.height = `${item.dataset[height]}px`
      item.style.transform = `rotate(${item.dataset[rotate]}deg)`
    })
  }
}
customElements.define('spiral-distribution', SpiralDistribution)


class VideoHeroV6 extends HTMLElement {
  constructor() {
    super()
    this.isMobileMedia = window.matchMedia(theme.config.mediaQuerySmall)
    this.imageSeqUrl = this.dataset.imageSeqUrl
    this.imageSeqUrlMobile = this.dataset.imageSeqUrlMobile
    this.frameStart = parseInt(this.dataset.imageSeqStart)
    this.frameEnd = parseInt(this.dataset.imageSeqEnd)
    this.frameCount = this.frameEnd - this.frameStart
    this.canvas = this.querySelector('canvas')
    this.context = this.canvas.getContext("2d")
    // { src: '', loaded: false }
    this.imagesCache = []

    this.initImageCache()
    if (this.frameEnd > this.frameStart) {
      this.init()
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startLoadImages(this.isMobileMedia.matches).then(() => {
            })
            observer.unobserve(this)
          }
        })
      },
      {
        rootMargin: "400px", // 关键！提前 400px 触发
        threshold: 0, // 只要进入扩展区域就触发
      }
    )

    observer.observe(this)

  }

  get stickyContainer() {
    return this.querySelector('.vh6__sticky-container')
  }

  get contentBox() {
    return this.querySelector('.vh6__content-box')
  }

  get imageSeqUrlTemplate() {
    if (this.isMobileMedia.matches) {
      return this.imageSeqUrlMobile || this.imageSeqUrl
    } else {
      return this.imageSeqUrl
    }
  }


  connectedCallback() {
  }

	onFirstImageLoaded() {
		this.renderImage()
	}

  initImageCache() {
    const currentFrame = (urlTemplate, index) => {
      const seq = index.padStart(4, "0")
      return urlTemplate.replace('[xxxx]', seq)
    }
    let frameIndex = 1
    for (let i = this.frameStart; i <= this.frameEnd; i++) {
      this.imagesCache.push({
        src: currentFrame(this.imageSeqUrl, i + ''),
        srcMobile: currentFrame(this.imageSeqUrlMobile || this.imageSeqUrl, i + ''),
        frame: frameIndex++,
        loaded: false
      })
    }
  }

  async startLoadImages(isMobile, batchSize = 60, maxRetries = 2) {
    let retryCount = 0;

    while (true) {
      const remaining = this.imagesCache.filter(i => !i.loaded).length;
      if (remaining === 0) {
        // 所有图片加载完成
        break;
      }

      const results = await this.loadImages(batchSize, isMobile);
      // const failed = results.filter(r => r.status === 'rejected');

      // if (failed.length > 0) {
      //    console.warn(`${failed.length} 张图片加载失败`, failed.map(f => f.reason.message));
          
      //    if (retryCount < maxRetries) {
      //        retryCount++;
      //        console.log(`第 ${retryCount} 次重试...`);
      //    } else {
      //        console.error('达到最大重试次数，跳过剩余错误');
      //        break;
      //    }
      // } else {
      //    retryCount = 0; // 成功时重置重试计数
      // }
    }
  }

  loadImages(total = 60, isMobile) {
    const arr = this.imagesCache.filter(i => i.loaded == false).slice(0, total)
    const promises = arr.map(imageObj => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = isMobile ? imageObj.srcMobile : imageObj.src;
            img.onload = () => {
                imageObj.loaded = true;
                imageObj.imgElement = img
								if (imageObj.frame == 1) {
									this.onFirstImageLoaded()
								}
                resolve(imageObj); // 加载成功
            };
            img.onerror = () => {
                imageObj.loaded = true;
                this.images.push(false)
                reject(new Error(`Failed to load: ${imageObj.src}`)); // 加载失败
            };
        });
    });

    // 等待所有图片加载完成
    return Promise.allSettled(promises)
  }

  init() {

    this.canvas.width = this.canvas.offsetWidth;
    this.canvas.height = this.canvas.offsetHeight;

    this.airpods = {
      frame: 0
    };

    const render = this.renderImage.bind(this)

    const masterTL = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: 'top top',
        pin: true,
        scrub: 0.8
      }
    });

    const frameAnim = masterTL.to(this.airpods, {
      frame: this.frameCount - 1,
      snap: "frame",
      ease: "none",
      duration: (this.frameCount - 1) / 60,
      onUpdate: render
    });

    masterTL.to(
      this.contentBox,
      {
        scale: 0.5,
        opacity: 0,
        ease: "none",
        duration: 1.6
      },
      0
    );

    masterTL.to(
      this.stickyContainer,
      {
        left: 40,
        right: 40,
        bottom: 40,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        ease: "power2.out"
      },
      frameAnim.duration() * 0.9
    );
  }


  renderImage() {
    const image = this.imagesCache[this.airpods.frame]
    if (image.loaded) {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.drawImage(image.imgElement, 0, 0, this.canvas.width, this.canvas.height);
    }
  }

}
customElements.define('video-hero-v6', VideoHeroV6);

